import React, { useState } from 'react';
import { Pagination as PaginationComponent } from '@totalsoft/rocket-ui';
import { useCallback } from 'react';

const defaultPager = {
  totalCount: 0,
  pageSize: 10,
  afterId: 1,
  page: 0,
  rowsPerPageOptions: [10, 25, 50, 100]
};

const usePagination = overridenProps => {
  const [pager, setPager] = useState({ ...defaultPager, ...overridenProps });

  const updatePager = useCallback(props => {
    setPager(prev => ({ ...prev, ...props }));
  }, []);

  const updateSize = useCallback(size => {
    setPager(prev => ({ ...prev, pageSize: Number(size) }));
  }, []);

  const updatePage = useCallback(page => {
    setPager(prev => ({ ...prev, page, afterId: page + 1 }));
  }, []);

  const Pagination = useCallback(
    ({ loading, onRefresh }) => (
      <PaginationComponent
        count={pager.totalCount}
        pageSize={pager.pageSize}
        page={pager.page}
        loading={loading}
        onRowsPerPageChange={updateSize}
        onPageChange={updatePage}
        onRefresh={onRefresh}
        rowsPerPageOptions={pager.rowsPerPageOptions}
      />
    ),
    [pager, updateSize, updatePage]
  );

  return { Pagination, pager, updatePager };
};

export default usePagination;
